/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_INVOICE_DETAILS_BY_PQR = 'GET_INVOICE_DETAILS_BY_PQR';
export const GET_INVOICE_DETAILS_BY_INVOICE_NUM =
  'GET_INVOICE_DETAILS_BY_INVOICE_NUM';
export const GET_HANDLING_CODE = 'GET_HANDLING_CODE';
export const GET_BALANCE_CODE = 'GET_BALANCE_CODE';
export const GET_INVOICE_QUARTER = 'GET_INVOICE_QUARTER';
export const GET_INVOICE_CODE = 'GET_INVOICE_CODE';
export const GET_INVOICE_OTHER_QUARTER = 'GET_INVOICE_OTHER_QUARTER';
export const GET_INVOICE_QUARTER_TOTALS = 'GET_INVOICE_QUARTER_TOTALS';
export const SAVED_INVOICE_DETAILS = 'SAVED_INVOICE_DETAILS';
export const GET_DRUG_ACTIVITY = 'GET_DRUG_ACTIVITY';
export const GET_CHECK_LOG_BY_INVOICE_NUM = 'GET_CHECK_LOG_BY_INVOICE_NUM';
export const SET_INVOICE_NUMBER = 'SET_DISPLAY_INVOICE_NUMBER';
export const SET_SELECTED_CLIENT = 'SET_DISPLAY_INVOICE_SELECTED_CLIENT';
export const SET_DEFAULT_QTR = 'SET_DISPLAY_INVOICE_DEFAULT_QTR';
export const SET_ERROR_MESSAGES = 'SET_DISPLAY_INVOICE_ERROR_MESSAGES';
export const RESET_DISPLAY_INVOICE_STORE = 'RESET_DISPLAY_INVOICE_STORE';
export const INVOICE_QTR = 'INVOICE_QTR';
export const DISPLAY_INVOICE_OBJ = 'DISPLAY_INVOICE_OBJ';
export const MFG_SELECTED = 'MFG_SELECTED';
export const SET_INVOICE_OTHER_HIDE_ZERO_BALANCE = 'SET_INVOICE_OTHER_HIDE_ZERO_BALANCE';
export const SET_INVOICE_OTHER_SELECTED_QTR = 'SET_INVOICE_OTHER_SELECTED_QTR';
export const SET_NO_RECORD_FOUND = 'SET_DISPLAY_INVOICE_NO_RECORD_FOUND';
